import { Icon } from '@iconify/react'
import locationIcon from '@iconify/icons-noto/volcano'

const Header = () => {
    return (
        <header className="header">
            <h1><Icon icon={locationIcon} /> Active Volcanoes Tracker (Powered By NASA)</h1>
        </header>
    )
}

export default Header
